import { CreateMapping } from 'Store/common/common.types'
import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  ListReq,
  ListRes,
  DetailReq,
  DetailRes,
  ActionRes,
  UpdateReq,
  ApproveReq,
  RejectReq,
  MasterMerchantReq,
  MasterMerchantRes,
  DropdownReq,
  DropdownRes,
  PointHistoryReq,
  PointHistoryRes,
  PointSummaryReq,
  PointSummaryRes,
  PointRedeemReq,
  PointRedeemRes,
} from './types'

export const getListAction = createAsyncAction(
  'MERCHANTS/GET_MERCHANTS_LIST_REQ',
  'MERCHANTS/GET_MERCHANTS_LIST_SUCCESS',
  'MERCHANTS/GET_MERCHANTS_LIST_FAILURE',
)<ListReq, ListRes, Error>()

export const getDetailAction = createAsyncAction(
  'MERCHANTS/GET_MERCHANTS_DETAIL_REQ',
  'MERCHANTS/GET_MERCHANTS_DETAIL_SUCCESS',
  'MERCHANTS/GET_MERCHANTS_DETAIL_FAILURE',
)<DetailReq, DetailRes, Error>()

export const approveAction = createAsyncAction(
  'MERCHANTS/CREATE_MERCHANTS_REQ',
  'MERCHANTS/CREATE_MERCHANTS_SUCCESS',
  'MERCHANTS/CREATE_MERCHANTS_FAILURE',
)<ApproveReq, ActionRes, Error>()

export const rejectAction = createAsyncAction(
  'MERCHANTS/CREATE_MERCHANTS_REQ',
  'MERCHANTS/CREATE_MERCHANTS_SUCCESS',
  'MERCHANTS/CREATE_MERCHANTS_FAILURE',
)<RejectReq, ActionRes, Error>()

export const updateAction = createAsyncAction(
  'MERCHANTS/UPDATE_MERCHANTS_REQ',
  'MERCHANTS/UPDATE_MERCHANTS_SUCCESS',
  'MERCHANTS/UPDATE_MERCHANTS_FAILURE',
)<CreateMapping<UpdateReq>, ActionRes, Error>()

export const getMasterMerchantAction = createAsyncAction(
  'MERCHANTS/GET_MASTER_MERCHANTS_LIST_REQ',
  'MERCHANTS/GET_MASTER_MERCHANTS_LIST_SUCCESS',
  'MERCHANTS/GET_MASTER_MERCHANTS_LIST_FAILURE',
)<MasterMerchantReq, MasterMerchantRes, Error>()

export const getMerchantDropdownAction = createAsyncAction(
  'MERCHANT/GET_MERCHANT_DROPDOWN_REQ',
  'MERCHANT/GET_MERCHANT_DROPDOWN_SUCCESS',
  'MERCHANT/GET_MERCHANT_DROPDOWN_FAILURE',
)<DropdownReq, DropdownRes, Error>()

export const getPointHistoryAction = createAsyncAction(
  'MERCHANTS/GET_POINT_HISTORY_REQ',
  'MERCHANTS/GET_POINT_HISTORY_SUCCESS',
  'MERCHANTS/GET_POINT_HISTORY_FAILURE',
)<PointHistoryReq, PointHistoryRes, Error>()

export const getPointSummaryAction = createAsyncAction(
  'MERCHANTS/GET_POINT_SUMMARY_REQ',
  'MERCHANTS/GET_POINT_SUMMARY_SUCCESS',
  'MERCHANTS/GET_POINT_SUMMARY_FAILURE',
)<PointSummaryReq, PointSummaryRes, Error>()

export const getPointRedeemAction = createAsyncAction(
  'MERCHANTS/GET_POINT_REDEEM_REQ',
  'MERCHANTS/GET_POINT_REDEEM_SUCCESS',
  'MERCHANTS/GET_POINT_REDEEM_FAILURE',
)<PointRedeemReq, PointRedeemRes, Error>()

export const clearEventAction = createStandardAction('MERCHANTS/CLEAR_EVENT')<void>()
